import { chatApi } from '../api';
import { runUpload, type UploadedFile, type UploadOptions, type UploadScope } from './upload';

/**
 * Uploads one file into `scope` through the app's own API, every part to its
 * own URL - see `runUpload`. The ONE way a file leaves this client: chat and
 * channel attachments, voice messages, voicemail and profile pictures.
 */
export function uploadFile(file: File, scope: UploadScope, options: UploadOptions = {}): Promise<UploadedFile> {
  return runUpload(chatApi, file, scope, options);
}
